export function isDevelopment() {
  return process.env.NODE_ENV !== "production";
}

export function isDebugMode() {
  return localStorage.getItem("debug") === "ea";
}
